import {lazy} from 'react'

export default function preloadedLazy(importCallback) {
  const modulePromise = importCallback()

  return lazy(() => modulePromise)
}
